const DEFAULT_MESSAGE = 'Failed to update selection';

export class SelectionError extends Error {
  constructor(message = DEFAULT_MESSAGE) {
    super(message);
  }
}
